import { TruckIcon } from "@heroicons/react/20/solid";
import { APPOINTMENT_TYPES } from "../../config/appointment";

const SIZE_CLASSES = {
  sm: {
    wrapper: "px-2 py-0.5 text-xs gap-x-1",
    icon: "size-3.5",
  },
  xs: {
    wrapper: "px-1.5 py-0.5 text-[11px] gap-x-1",
    icon: "size-3",
  },
};

const AppointmentTypeBadge = ({ type, size = "sm" }) => {
  if (type !== APPOINTMENT_TYPES.MOBILE) return null;

  const resolvedSize = SIZE_CLASSES[size] ? size : "sm";
  const classes = SIZE_CLASSES[resolvedSize];

  return (
    <span
      data-size={resolvedSize}
      className={`inline-flex items-center rounded-pill font-medium bg-signal-amber-50 text-signal-amber-600 ring-1 ring-inset ring-signal-amber-100 ${classes.wrapper}`}
    >
      <TruckIcon className={classes.icon} aria-hidden="true" />
      Mobile
    </span>
  );
};

export default AppointmentTypeBadge;
